import { render, staticRenderFns } from "./distributorlist.vue?vue&type=template&id=3099993c&scoped=true"
import script from "./distributorlist.vue?vue&type=script&lang=js"
export * from "./distributorlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3099993c",
  null
  
)

export default component.exports